<template>
  <div class="confidence-card">
    <div class="high" v-if="score >= 90">
      <span> {{ score }}% </span>
    </div>
    <div class="medium" v-if="score < 90 && score >= 80">
      <span> {{ score }}% </span>
    </div>
    <div class="low" v-if="score < 80">
      <span> {{ score }}% </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneCard',
  props: ['score']
}
</script>

<style scoped lang="scss">
.confidence-card {
  display: flex;
  .high {
    background: #2edb89;
  }
  .medium,
  .low,
  .high {
    color: #fff;
    font-size: 14px;
    line-height: 22px;
    border-radius: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 6px;
  }
  .medium {
    background: $orange;
  }
  .low {
    background: $sandal-yellow;
  }
}
</style>
